import React, { Component } from "react";
import "./style.scss";

import rightChevronSVG from "./assets/filter-right-arrow.svg";
import downChevronSVG from "./assets/filter-down-arrow.svg";

class FilterSection extends Component {
  constructor(props) {
    super(props)
    this.filterMap = {
      'musicType': 'Music',
      'classDuration': 'Duration'
    }
  }

  handleLabelClick = e => {
    let a = (e.currentTarget).parentElement.querySelector('.filter-option-main');
    if(a.style.display === 'none') {
      a.style.display = 'flex';
      (e.currentTarget).parentElement.querySelector('.filter-section-icon img').src = downChevronSVG
    } else {
      a.style.display = 'none';
      (e.currentTarget).parentElement.querySelector('.filter-section-icon img').src = rightChevronSVG
    }
  };
  render() {
    const { toggleItemSelection, filterTags, chosenFilterTags } = this.props,
    filterHeadings = (Object.keys(filterTags));
    return (
      <div>
      {(filterHeadings.length > 0) && filterHeadings.map((filterHeading, headingIndex) => (
        <div className="filter-section" key={headingIndex}>
            <div className="filter-section-heading" onClick={e => this.handleLabelClick(e)}>
              {this.filterMap[filterHeading] || (filterHeading && filterHeading.replace(/([a-z])([A-Z])/g, '$1 $2'))}
              <span className="filter-section-icon">
                <img src={rightChevronSVG} alt="arrow" />
              </span>
              <span className="filter-selected">{(chosenFilterTags[filterHeading] && chosenFilterTags[filterHeading].length) ? `${chosenFilterTags[filterHeading].length} selected` : null}</span>
            </div>
            <div className="filter-option-main" style={{'display': 'none'}}>
              {filterTags[filterHeading].map((option, optionIndex) => (
                  <div className={`filter-section-option ${chosenFilterTags[filterHeading] && chosenFilterTags[filterHeading].includes(option.title) ? 'activeOption' :''}`} 
                    key={optionIndex} 
                    onClick={() => toggleItemSelection(option.title,filterHeading)}>
                    <span className="filter-section-option-text">{option.title}</span>
                  </div>
                ))}
            </div>
        </div>)
        )}
        </div>
     ) }
}

export default FilterSection;
